document.addEventListener("DOMContentLoaded",function()
{

   function init()
   {

        eventos();

   }


   function eventos()
   {


        eventos_click();
       


   }


   const node_boton_disminuirstock = document.getElementById("minorar-stock");
   const node_input_stock = document.getElementById("stock");
   const node_boton_aumentarstock = document.getElementById("aumentar-stock");
   const arr_nodo_lineitems = document.querySelectorAll("#carrito-lateral .line_item");

   function eventos_click()
   {

        click_variaciones();
        click_arr_minorar_o_aumentar_unidades(arr_nodo_lineitems);
        click_minorarunidades(node_boton_disminuirstock,node_input_stock,node_boton_aumentarstock);
        click_aumentarunidades(node_boton_disminuirstock,node_input_stock,node_boton_aumentarstock);
        click_botonagregar_productoalcarrito();

   }

  


   function click_variaciones()
   {


          const arr_node_radio = document.querySelectorAll("input[type='radio']");


               for(const node_radio of arr_node_radio)
               {

                    node_radio.addEventListener("change",function(e)
                    {

                         const elemento = e.target;

                         
                              
                              activar_opcionseleccionada(elemento);     
                              actualizar_informaciondeproducto();

                              

                         

                    });

               }

       

   }


   function click_botonagregar_productoalcarrito()
   {

          const node_boton_agregarproducto_alcarrito = document.querySelector(".btn-compra");



          node_boton_agregarproducto_alcarrito.addEventListener("click",function(e)
          {    

               e.preventDefault();

               agregar_productoalcarrito(e);

          });


   }


   function agregar_productoalcarrito(e)
   {


          let int_idvariacion_f = parseInt(document.getElementById("id-variacionseleccionada").value),
              int_unidadesque_deseaagregar_alcarrito_f = parseInt(document.getElementById("stock").value);



          let formData = {


                              "items":[

                                             {

                                                  "id":int_idvariacion_f,
                                                  "quantity":int_unidadesque_deseaagregar_alcarrito_f

                                             }

                                        ]


                          };

          fetch(
               
                    "/cart/add.js",
                    {
                         
                         method:"POST",
                         headers:{

                                   "Content-Type":"application/json"

                                 },
                         body:JSON.stringify(formData)

                    }
          
               )
          .then((response)=>
               {
                   return response.json();

               })

          .then((data)=>
               {
                 
                    actualizar_carritodecompras();
                    

               })

          .catch((error)=>{



               console.error("ERROR, AL AGREGAR PRODUCTO AL CARRITO ",error);

          });
         


   }

    
    
    
   function click_minorarunidades(node_boton_disminuirstock,node_input_stock,node_boton_aumentarstock)
   {


     node_boton_disminuirstock.addEventListener("click",function(e)
     {

         
          e.preventDefault();

          const elemento = e.target;
          if(!elemento.disabled)
          {

               disminuirunidades_quese_deseaagregar_alcarrito(node_input_stock);
               actualizar_botonesde_agregarodisminuirstock(node_input_stock,node_boton_disminuirstock,node_boton_aumentarstock)

          }
          

     });

   }

   function click_aumentarunidades(node_boton_disminuirstock,node_input_stock,node_boton_aumentarstock)
   {

         

          

          node_boton_aumentarstock.addEventListener("click",function(e)
          {

             
               e.preventDefault();
               const elemento = e.target;
               if(!elemento.disabled)
               {
                    console.log(node_input_stock);
                    aumentarunidades_quese_deseaagregar_alcarrito(node_input_stock);
                    actualizar_botonesde_agregarodisminuirstock(node_input_stock,node_boton_disminuirstock,node_boton_aumentarstock);

               }
               

          });



   }

   function disminuirunidades_quese_deseaagregar_alcarrito(node_input_stock)
   {

   
     let int_unidadesque_deseaagregar_alcarrito = parseInt(node_input_stock.value);


     if(int_unidadesque_deseaagregar_alcarrito>1)
     {
          

          node_input_stock.value = int_unidadesque_deseaagregar_alcarrito - 1;

     }


     actualizar_estadodenodos_parastock_enproducto(node_input_stock);


   }

   function aumentarunidades_quese_deseaagregar_alcarrito(node_input_stock)
   {


     let int_unidadesque_deseaagregar_alcarrito = parseInt(node_input_stock.value);
     let int_unidadesmaximas_quese_puedeagregar_alcarrito = parseInt(node_input_stock.getAttribute("max"));



     if(int_unidadesmaximas_quese_puedeagregar_alcarrito>int_unidadesque_deseaagregar_alcarrito)
     {
        

          node_input_stock.value = int_unidadesque_deseaagregar_alcarrito + 1;

     }



     actualizar_estadodenodos_parastock_enproducto(node_input_stock);

    




   }

   function actualizar_estadodenodos_parastock_enproducto(node_input_stock)
   {


     const formulario_producto = document.querySelector(".formulario-producto");

     if(formulario_producto)
     {


          let int_idvariacion_f = parseInt(document.getElementById("id-variacionseleccionada").value);

          if(node_input_stock.closest("#carrito-lateral") && parseInt(node_input_stock.closest(".line_item").getAttribute("id")) ==  int_idvariacion_f)
          {

               const node_input_stock_producto = document.querySelector("#stock");
               node_input_stock_producto.setAttribute("max", ( parseInt(node_input_stock.getAttribute("max")) -  parseInt(node_input_stock.value)));

               const node_boton_disminuirstock_producto = document.querySelector("#minorar-stock");
               const node_boton_aumentarstock_producto = document.querySelector("#aumentar-stock");

               actualizar_botonesde_agregarodisminuirstock(node_input_stock_producto,node_boton_disminuirstock_producto,node_boton_aumentarstock_producto);

          }


     }
          


   }


   function activar_opcionseleccionada(elemento)
   {

        //Despintar actual opción seleccionada
        const node_label_actual_opcioneSeleccionada = elemento.closest(".valores_option").querySelector(".seleccionado");
        node_label_actual_opcioneSeleccionada.classList.remove("seleccionado");


        //Pintar nueva opción seleccionada
        const str_radio_idopcioneseleccionada = elemento.getAttribute("id");
        const node_label_opcionseleccionada = document.querySelector(`label[for='${str_radio_idopcioneseleccionada}']`);
        node_label_opcionseleccionada.classList.add("seleccionado");



   }

   const arr_variaciones = window.variaciones;
   const str_divisa = "USD";
   let obj_informacion_devariacionseleccionada = null;
   if(arr_variaciones)
    {

        actualizar_informaciondeproducto();

    }

   function actualizar_informaciondeproducto()
   {

        
        const arr_str_variacionseleccionada = obtener_variacionseleccionada();
        
        obj_informacion_devariacionseleccionada = obtener_informacion_devariacionseleccionada(arr_str_variacionseleccionada);

       

        actualizar_sku_deproducto(obj_informacion_devariacionseleccionada);
        actualizar_precionormal_deproducto(obj_informacion_devariacionseleccionada);
        actualizar_preciocomparacion_deproducto(obj_informacion_devariacionseleccionada);

        actualizar_nodos_deproducto_enbaseastock(obj_informacion_devariacionseleccionada);

       
        
       
     

   }

   function actualizar_carritodecompras()
   {


     fetch("/?section_id=sidecart-v02")
     .then((res)=>{
                         return res.text();
                  }
          )

     .then((html)=>{

          let nodo_carritolateralnuevo = new DOMParser().parseFromString(html,"text/html").querySelector("#carrito-lateral");
          let nodo_carritolateralactual = document.getElementById("carrito-lateral");

          nodo_carritolateralactual.innerHTML = nodo_carritolateralnuevo.innerHTML;

          actualizar_nodos_deproducto_enbaseastock(obj_informacion_devariacionseleccionada);
          click_arr_minorar_o_aumentar_unidades(nodo_carritolateralactual.querySelectorAll(".line_item"));
         

     })
     
     .catch((error)=>{

          console.error("ERROR AL OBTENER HTML DEL CARRITO ",error);

     })
    
   }

   function  click_arr_minorar_o_aumentar_unidades(arr_nodo_lineitems)
   {

          arr_nodo_lineitems.forEach((nodo_lineitem)=>{

               const node_boton_disminuirstock = nodo_lineitem.querySelector(".btn-disminuirstock-carritolateral");
               const node_input_stock = nodo_lineitem.querySelector(".stock-carritolateral");
               const node_boton_aumentarstock = nodo_lineitem.querySelector(".btn-aumentarstock-carritolateral");

               click_minorarunidades(node_boton_disminuirstock,node_input_stock,node_boton_aumentarstock);
               click_aumentarunidades(node_boton_disminuirstock,node_input_stock,node_boton_aumentarstock);

          });


   }

   function obtener_variacionseleccionada()
   {

      const arr_node_contenedoropciones = document.querySelectorAll(".valores_option"); 
      const arr_str_variacionseleccionada = [];
      
     if(arr_node_contenedoropciones.length>0) //Producto Variable
     {


          for(const node_contenedoropciones of arr_node_contenedoropciones)
               {
                    
                    const arr_node_opciones = node_contenedoropciones.querySelectorAll("input");   
               
                    const str_opcionseleccionada = obtener_opcionseleccionada(arr_node_opciones);

                    arr_str_variacionseleccionada.push(str_opcionseleccionada);

               }

          return arr_str_variacionseleccionada;


     }else //Producto Simple
     {

          arr_str_variacionseleccionada.push("producto simple");

          return arr_str_variacionseleccionada;

     }
          


   }

   function obtener_opcionseleccionada(arr_node_opciones)
   {
         
          for(let i=0; i<arr_node_opciones.length; i++)
               {

                    const node_opcion = arr_node_opciones[i];
                   

                    if(node_opcion.checked)
                    {

                         const str_opcionseleccionada = node_opcion.value;
                        
                         
                         
                         return str_opcionseleccionada;
                         
                    
                    }


               }

         


   }

   function obtener_informacion_devariacionseleccionada(arr_str_variacionseleccionada)
   {

     if(arr_str_variacionseleccionada[0]=="producto simple")
     {

          return arr_variaciones[0];


     }else
     {

          for(const variacion of arr_variaciones)
          {

          

               if( variacion.options.length ==arr_str_variacionseleccionada.length)
               {

                    if(variacion.options.every((opcion,i)=> opcion == arr_str_variacionseleccionada[i]))
                    {

                         return variacion;

                    }

               }

          

               

               
          }


     }
    
          


   }


   function actualizar_sku_deproducto(obj_informacion_devariacionseleccionada)
   {

     const {sku:str_sku} = obj_informacion_devariacionseleccionada;

     const node_sku = document.getElementById("sku");
     node_sku.innerHTML = str_sku;

   }

   function actualizar_precionormal_deproducto(obj_informacion_devariacionseleccionada)
   {

          const {price:double_precio} = obj_informacion_devariacionseleccionada;
          const node_precionormal_deproducto = document.querySelector(".precio-normal");

          if(double_precio)
          {
               const str_precioformateado = formatear_moneda(str_divisa,double_precio/100);

          

               

               node_precionormal_deproducto.innerHTML = str_precioformateado;

          }else
          {

             node_precionormal_deproducto.innerHTML = "";

          }


   }


   function actualizar_preciocomparacion_deproducto(obj_informacion_devariacionseleccionada)
   {

          const {compare_at_price:double_preciocomparacion} = obj_informacion_devariacionseleccionada;
          const node_preciocomparacion_deproducto = document.querySelector(".precio-comparacion");
          if(double_preciocomparacion)
          {
               

               const str_precioformateado = formatear_moneda(str_divisa,double_preciocomparacion/100);
              
               node_preciocomparacion_deproducto.innerHTML = str_precioformateado;

          }else
          {

               node_preciocomparacion_deproducto.innerHTML = "";

          }


   }

   function formatear_moneda(str_divisa,double_monto)
   {

          switch(str_divisa)
          {

               case "USD":
                    
                    double_monto = double_monto.toLocaleString("en-US",{

                                                                           style:"currency",
                                                                           currency:"USD"


                                                                        }
                                                               );

                 

               ;break;


          }


          return double_monto;

   }

   function actualizar_nodos_deproducto_enbaseastock(obj_informacion_devariacionseleccionada)
   {

        actualizar_inputdestock(obj_informacion_devariacionseleccionada);
        actualizar_botonesde_agregarodisminuirstock(node_input_stock,node_boton_disminuirstock,node_boton_aumentarstock);
        actualizar_botonde_agregaralcarrito(obj_informacion_devariacionseleccionada);

   }

   function actualizar_inputdestock(obj_informacion_devariacionseleccionada)
   {

          const {inventory_quantity:int_stock, id:int_idvariacion} = obj_informacion_devariacionseleccionada;
          
          let int_unidadesencarrito_lineitem = obtener_unidadesagregadas_alcarrito_deproductox(int_idvariacion)
          
          node_input_stock.setAttribute("max",(int_stock - int_unidadesencarrito_lineitem <= 0 ? 1 :  int_stock - int_unidadesencarrito_lineitem));
          node_input_stock.value="1";

   }

   function obtener_unidadesagregadas_alcarrito_deproductox(int_idvariacion)
   {

          const nodo_lineitem_decarrito = document.getElementById(int_idvariacion);
          let int_unidadesencarrito_lineitem = 0;
          if(nodo_lineitem_decarrito)
          {


               const nodo_inputunidadesencarrito_lineitem = nodo_lineitem_decarrito.querySelector(".stock-carritolateral");
               int_unidadesencarrito_lineitem = parseInt(nodo_inputunidadesencarrito_lineitem.value);

          }

          return  int_unidadesencarrito_lineitem;
          

   }

   function actualizar_botonesde_agregarodisminuirstock(node_input_stock,node_boton_disminuirstock,node_boton_aumentarstock)
   {

          console.log("INPUT STOCK : ",node_input_stock);
          console.log("INPUT DISMINUIR STOCK : ",node_boton_disminuirstock);
          console.log("INPUT AUMENTAR STOCK : ",node_boton_aumentarstock);
        

          actualizar_botonde_disminuirstock(node_input_stock,node_boton_disminuirstock);
          actualizar_botonde_agregarstock(node_input_stock,node_boton_aumentarstock);


   }


   function actualizar_botonde_disminuirstock(node_input_stock,node_boton_disminuirstock)
   {

   
   
     const int_unidadesque_sedesea_agregaral_carrito = obtener_unidadesque_sedesea_agregaral_carrito(node_input_stock);


     if(int_unidadesque_sedesea_agregaral_carrito>1)
     {
         
          node_boton_disminuirstock.disabled = false;
         

     }else
     {
          
          node_boton_disminuirstock.disabled = true;

     }


   }

   function actualizar_botonde_agregarstock(node_input_stock,node_boton_aumentarstock)
   {
     
          const int_unidadesque_sedesea_agregaral_carrito = obtener_unidadesque_sedesea_agregaral_carrito(node_input_stock);
          console.log("UNIDADES QUE SE DESEA AGREGAR AL CARRITO : ",int_unidadesque_sedesea_agregaral_carrito);
          const int_unidadesmaximas_quese_puedeagregar_alcarrito = obtener_unidadesmaximas_quese_puedeagregar_alcarrito(node_input_stock);
          
          
          if(int_unidadesmaximas_quese_puedeagregar_alcarrito > int_unidadesque_sedesea_agregaral_carrito)
          {

               node_boton_aumentarstock.disabled = false;

          }else
          {

               node_boton_aumentarstock.disabled = true;

          }


   }

   function obtener_unidadesque_sedesea_agregaral_carrito(node_input_stock)
   {
     
          const int_unidadesque_sedesea_agregaral_carrito = parseInt(node_input_stock.value);

          return int_unidadesque_sedesea_agregaral_carrito;


   }

   function obtener_unidadesmaximas_quese_puedeagregar_alcarrito(node_input_stock)
   {

          // const node_inputstock = document.getElementById("stock");
          const int_unidadesmaximas_quese_puedeagregar_alcarrito = parseInt(node_input_stock.getAttribute("max"));

          return int_unidadesmaximas_quese_puedeagregar_alcarrito;

   }

   function actualizar_botonde_agregaralcarrito(obj_informacion_devariacionseleccionada)
   {
         const {inventory_quantity:int_stock, id:int_idvariacion} = obj_informacion_devariacionseleccionada;
          
          let int_unidadesencarrito_lineitem = obtener_unidadesagregadas_alcarrito_deproductox(int_idvariacion)
          
          
         



       

          const node_boton_agregaralcarrito = document.querySelector(".btn-compra");
          if(int_stock - int_unidadesencarrito_lineitem > 0)
          {
              
               node_boton_agregaralcarrito.disabled = false;
               node_boton_agregaralcarrito.innerHTML = "Agregar al carrito";

          }else
          {

                node_boton_agregaralcarrito.disabled = true;
                node_boton_agregaralcarrito.innerHTML = "Sin stock";

          }


   }
    

    init();
    
 

});